/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from 'src/app/models/user';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { UiService } from '../ui.service';
import { PushNotificationService } from '../push-notification/push-notification.service';
import { SmartHttpService } from '../smart-http/smart-http.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };
  // tslint:disable-next-line: max-line-length
  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private envService: TxService,
    private localStorageData: LocalStorageService,
    private uiService: UiService,
    private txService: TxService,
    private router: Router
  ) {
    this.initApiParams();
  }

  public get redirectUrl(): string {
    return this.localStorageData.getItem(localStorageKeys.REDIRECT_URL);
  }

  public set redirectUrl(value: string) {
    this.localStorageData.setItem(localStorageKeys.REDIRECT_URL, value);
  }

  private get validateSerialNumberApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.validateSerialNumberApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get logoutApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.logoutApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get searchCityApi(): string {
    const defaultParams: any = {
      ...this.envService.getDefaultApiParams(),
    };
    const orderedParams: any = { ...defaultParams };
    if (this.apiParams?.countryCode) {
      orderedParams.countryCode = this.apiParams.countryCode;
    }
    if (this.apiParams?.q) {
      orderedParams.q = this.apiParams.q;
    }
    if (this.apiParams?.page !== undefined) {
      orderedParams.page = this.apiParams.page;
    }
    return (this.sendOtpApi = `${this.envService.searchCityApi()}?${this.helperService.serializeToGetParams(
      orderedParams
    )}`);
  }

  private get userRegistrationApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.userRegistrationApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get sendOtpApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.sendOtpApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get sendEmailOtpApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendEmailOtpApi = `${this.envService.sendEmailOtpApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get checkSoftLoginApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.checkSoftLoginApi = `${this.envService.checkSoftLoginApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get checkGuestLoginApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.checkGuestLoginApi = `${this.envService.checkGuestLoginApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get changeUserTypeApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.changeUserTypeApi = `${this.envService.changeUserTypeApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get getCountriesApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.getCountriesApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get getCitiesByCountryApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.getCitiesByCountryApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get deactivateUserApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.sendOtpApi = `${this.envService.deactivateUserApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get verifyOtpApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.verifyOtpApi = `${this.envService.verifyOtpApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get verifyLoginApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.verifyLoginApi = `${this.envService.verifyLoginApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get getPointsApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.verifyOtpApi = `${this.envService.getPointsApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get registrationFormApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.registrationFormApi = `${this.envService.getRegistrationFormApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get getUserGuestListApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.getUserGuestListApi = `${this.envService.getUserGuestListApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get getUserGuestListV2Api(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.getUserGuestListV2Api = `${this.envService.getUserGuestListV2Api()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }
  private get editUserGuestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.editUserGuestApi = `${this.envService.editUserGuestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get addUserGuestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.addUserGuestApi = `${this.envService.addUserGuestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private get deleteUserGuestApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    return (this.deleteUserGuestApi = `${this.envService.deleteUserGuestApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  private set getPointsApi(value: string) {}
  private set sendOtpApi(value: string) {}
  private set sendEmailOtpApi(value: string) {}
  private set checkSoftLoginApi(value: string) {}
  private set checkGuestLoginApi(value: string) {}
  private set changeUserTypeApi(value: string) {}

  private set verifyOtpApi(value: string) {}
  private set verifyLoginApi(value: string) {}
  private set registrationFormApi(value: string) {}
  private set getUserGuestListApi(value: string) {}
  private set getUserGuestListV2Api(value: string) {}
  private set addUserGuestApi(value: string) {}
  private set editUserGuestApi(value: string) {}
  private set deleteUserGuestApi(value: string) {}

  public get deviceSerialNumber(): string {
    return this.localStorageData.getItem(localStorageKeys.DEVICE_SERIAL_NUMBER);
  }
  public set deviceSerialNumber(value: string) {
    this.localStorageData.setItem(localStorageKeys.DEVICE_SERIAL_NUMBER, value);
  }

  public get token(): string {
    return this.localStorageData.getItem(localStorageKeys.TOKEN);
  }
  public set token(value: string) {
    this.localStorageData.setItem(localStorageKeys.TOKEN, value);
  }

  public get registered(): string {
    return this.localStorageData.getItem(localStorageKeys.REGISTRATION_TOKEN);
  }
  public set registered(value: string) {
    this.localStorageData.setItem(localStorageKeys.REGISTRATION_TOKEN, value);
  }

  public get userType(): string {
    return this.localStorageData.getCookie(localStorageKeys.USER_TYPE);
  }

  public set userType(value: string) {
    this.localStorageData.setCookies(localStorageKeys.USER_TYPE, value, 0);
  }


  public get isMember(): boolean {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.IS_MEMBER)
    );
  }
  public set isMember(value: boolean) {
    this.localStorageData.setItem(
      localStorageKeys.IS_MEMBER,
      JSON.stringify(value)
    );
  }

  public get phone(): string {
    return this.localStorageData.getItem(localStorageKeys.PHONE_NUMBER);
  }
  public set phone(value: string) {
    this.localStorageData.setItem(localStorageKeys.PHONE_NUMBER, value);
  }

  public get userInfo(): User {
    return JSON.parse(
      this.localStorageData.getItem(localStorageKeys.USER_INFO)
    );
  }
  public set userInfo(value: User) {
    this.localStorageData.setItem(
      localStorageKeys.USER_INFO,
      JSON.stringify(value)
    );
  }
  public getLoggedInUserId(): string | null {
    try {
      const raw = this.localStorageData.getItem(localStorageKeys.USER_INFO);
      if (!raw) {
        return null;
      }
      const userInfo = JSON.parse(raw);
      return this.normalizeId(userInfo?.userId ?? userInfo?.profileid);
    } catch {
      return null;
    }
  }

  public normalizeId(id: any): string | null {
    if (id === null || id === undefined) {
      return null;
    }
    const value = `${id}`.trim();
    return value === '' ? null : value;
  }
  public get deviceID(): string {
    return this.localStorageData.getItem(localStorageKeys.DEVICE_ID);
  }
  public set deviceID(value: string) {
    this.localStorageData.setItem(localStorageKeys.DEVICE_ID, value);
  }
  public get platformID(): string {
    return this.localStorageData.getItem(localStorageKeys.PLATFORM_ID);
  }
  public set platformID(value: string) {
    this.localStorageData.setItem(localStorageKeys.PLATFORM_ID, value);
  }

  getUserInfo(): User {
    return this.userInfo;
  }
  setUserInfo(user: User) {
    this.userInfo = user;
  }
  isLoggedIn() {
    return !!this.token;
  }

  public removeRedirectUrl() {
    this.localStorageData.removeItem(localStorageKeys.REDIRECT_URL);
  }

  isRegistered() {
    return !!this.registered;
  }

  // Set flag
  setAllowRegistration(value: number) {
    localStorage.setItem(localStorageKeys.ALLOW_REGISTRATION, value.toString());
  }

  // Get flag (default to 0 if not found)
  isRegistrationAllowed(): number {
    return Number(localStorage.getItem(localStorageKeys.ALLOW_REGISTRATION)) || 0;
  }

  // Reset flag after successful registration or logout
  resetRegistrationFlag() {
    localStorage.removeItem(localStorageKeys.ALLOW_REGISTRATION);
  }

  async logout() {
    this.apiParams.platformid = this.platformID;
    let userType = this.localStorageData.getItem(localStorageKeys.USER_TYPE);
    if (userType === 'bfl-prime') {
      userType = 'prime';
    } else if (userType === 'bfl-non-prime') {
      userType = 'non-prime';
    }

    let logintoken = this.token;
    if (localStorage.length > 0) {
      const excludeKeys = [
        localStorageKeys.PARTNER,
        localStorageKeys.CLIENT,
        localStorageKeys.MOBILE_REGISTRATION_TOKEN,
        localStorageKeys.DEVICE_ID,
        localStorageKeys.IS_UPDATE_MODAL,
        localStorageKeys.REFERAL_PARAMETER,
      ];
      for (const key in localStorage) {
        if (!excludeKeys.includes(key)) {
          localStorage.removeItem(key);
        }
      }
    }

    try {
      await this.httpClient
        .get(this.logoutApi, { headers: this.txService.getHeaders(logintoken) })
        .toPromise();
    } catch (error) {}
    
    const partnerData = JSON.parse(localStorage.getItem(localStorageKeys.PARTNER) || '{}');
    const defaultRoute = partnerData?.defaultRoute || 'home';
    window.location.href = `/${defaultRoute}`;
  }

  initApiParams() {
    this.apiParams = {};
  }
  // https://devapi.travelx.ai/api/validateSerialNumber?key=bvjhvfdvhjfdf&pid=viv&sn_no=13862352770001
  public validateSerialNumber(srNum: string): Observable<any> {
    this.apiParams.sn_no = srNum;
    return this.httpClient.get(this.validateSerialNumberApi);
  }

  public searchCity(
    q: string,
    page: number,
    countryCode?: string
  ): Observable<any> {
    if (q && q.trim().length > 0) {
      this.apiParams.q = q;
    }
    this.apiParams.page = page;
    if (countryCode) {
      this.apiParams.countryCode = countryCode;
    }
    return this.httpClient.get(this.searchCityApi);
  }

  // http://devapi.travelx.ai/api/userRegistration?key=bcqvmn2gabuu&pid=trxa
  public userRegistration(userObj): Observable<any> {
    this.apiParams.clientCode = JSON.parse(
      this.localStorageData.getItem(localStorageKeys.PARTNER)
    )?.clientCode;
    return this.httpClient.post(this.userRegistrationApi, userObj);
  }

  public sendOtp(mobnum: number, callingcode: any): Observable<any> {
    this.initApiParams();
    this.apiParams.mobnum = mobnum;
    this.apiParams.callingcode = callingcode;
    return this.httpClient.get(this.sendOtpApi);
  }

  public sendEmailOtp(email: string): Observable<any> {
    this.initApiParams();
    this.apiParams.email = email;
    return this.httpClient.get(this.sendEmailOtpApi);
  }

  public checkSoftLogin(token: any): Observable<any> {
    this.initApiParams();
    this.apiParams.token = token;
    return this.httpClient.get(this.checkSoftLoginApi);
  }

  public checkGuestLogin(hash: any, userType?: string, clientCode?: string): Observable<any> {
    this.initApiParams();
    this.apiParams.hash = hash;
    this.apiParams.user_type = userType;
    this.apiParams.clientCode = clientCode;
    const referalParameter = JSON.parse(
      this.localStorageData.getItem(localStorageKeys.REFERAL_PARAMETER) || '{}'
    );
    if (referalParameter?.tierId) {
      this.apiParams.tier_id = referalParameter.tierId;
    }
    return this.httpClient.get(this.checkGuestLoginApi);
  }

  public changeUserType(
    userType?: string,
    phoneNumber?: string,
    hash?: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.user_type = userType;
    this.apiParams.phone_num = phoneNumber;
    this.apiParams.hash = hash;
    const headers = this.txService.getHeaders(this.token);
    return this.httpClient.get(this.changeUserTypeApi, { headers });
  }

  public getCountries(searchTerm = '', pageNo): Observable<any> {
    this.initApiParams();
    this.apiParams.page = pageNo || 0;
    this.apiParams.q = searchTerm;
    return this.httpClient.get(this.getCountriesApi);
  }
  public getCitiesByCountry(countryCode: string): Observable<any> {
    this.initApiParams();
    this.apiParams.countryCode = countryCode;
    return this.httpClient.get(this.getCitiesByCountryApi);
  }
  public getPoints(page: number, count: number): Observable<any> {
    this.initApiParams();
    if (this.token) {
      this.apiParams.token = this.token;
    }
    this.apiParams.command = 'detailed';
    this.apiParams.page = page;
    this.apiParams.count = count;
    return this.httpClient.get(this.getPointsApi);
  }

  public verifyOtp(
    mobnum?: number,
    callingcode?: any,
    msgId?: string,
    otpId?: number,
    otp?: number,
    userType?: string,
    otpEmail?: string,
  ): Observable<any> {
    this.apiParams.msgId = msgId;
    this.apiParams.otpId = otpId;
    this.apiParams.otp = otp;
    this.apiParams.user_type = userType;
    if (mobnum) {
      this.apiParams.mobnum = mobnum;
    }
    if (callingcode) {
      this.apiParams.callingcode = callingcode;
    }
    if (otpEmail) {
      this.apiParams.otpEmail = otpEmail;
    }
    const partnerClientCode = JSON.parse(
      this.localStorageData.getItem(localStorageKeys.PARTNER) || '{}'
    )?.clientCode;
    if (partnerClientCode) {
      this.apiParams.clientCode = partnerClientCode;
    }
    const ssoRaw = localStorage.getItem(localStorageKeys.REFERAL_PARAMETER);
    const tierId = ssoRaw ? JSON.parse(ssoRaw)?.tierId : null;
    if (tierId) {
      this.apiParams.tier_id = tierId;
    }
    const guestTk = this.localStorageData.getItem(localStorageKeys.GUEST_TOKEN) || null;
    let headers = new HttpHeaders();

    if (guestTk) {
      headers = headers.set('Authorization', `Bearer ${guestTk}`);
    }

    return this.httpClient.get(this.verifyOtpApi, {
      params: this.apiParams,
      headers: headers,
    });
  }

  public deactivateUser(): Observable<any> {
    this.initApiParams();
    if (this.token) {
      this.apiParams.token = this.token;
    }
    return this.httpClient.get(this.deactivateUserApi);
  }

  public getRegistrationForm(): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    return this.httpClient.get(this.registrationFormApi);
  }

  public verifyLogin(
    phone_num: number,
    guestToken: string,
    callingCode: string
  ): Observable<any> {
    this.initApiParams();
    this.apiParams.phone_num = phone_num;
    this.apiParams.token = guestToken;
    this.apiParams.callingcode = callingCode;
    return this.httpClient.get(this.verifyLoginApi);
  }

  public getUserGuestList(): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    return this.httpClient.get(this.getUserGuestListApi);
  }
  public getUserGuestListV2(serviceType?: string): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    if (serviceType) {
      this.apiParams.serviceType = serviceType;
    }
    return this.httpClient.get(this.getUserGuestListV2Api);
  }

  public addUserGuest(guest, moduleType?: string): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    this.apiParams.moduleType = moduleType;
    return this.httpClient.post(this.addUserGuestApi, guest);
  }

  public editUserGuest(guestId: string, guest: any): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    this.apiParams.guestId = guestId;
    return this.httpClient.post(this.editUserGuestApi, guest);
  }

  public deleteUserGuest(guestId: string): Observable<any> {
    this.initApiParams();
    this.apiParams.token = this.token;
    this.apiParams.guestId = guestId;
    return this.httpClient.get(this.deleteUserGuestApi);
  }

  public isPrimeUserType(): boolean {
    const userType = this.localStorageData.getItem(localStorageKeys.USER_TYPE);
    return userType === 'bfl-prime';
  }

  public getToggleType(): any {
    let isPrime = JSON.parse(
      this.localStorageData.getItem(localStorageKeys.IS_PRIME_TOGGLE_ENABLED)
    );
    return isPrime ? 'bfl-prime' : 'bfl-non-prime';
  }
}
